import React from 'react';
import helpImage from '../icons/helpimg.jpg';

interface UATnowAction360Props {
    className?: string;
}

const UATnowAction360: React.FC<UATnowAction360Props> = ({ className }) => {
    const helpContent={
        title: "UAT is now Action 360",
        imageSrc: helpImage,
        imageAlt: "Action 360 feature illustration",
        description: "Unified Action Tracker is now renamed to Action 360 to reflect existing customized user experiences across businesses and AI capabilities. Users will experience the same great product with consistent and accessible experience with no changes to their current workflows."
    }
    return (
        <div className={className}>
            <p style={{fontWeight: '500'}}>{helpContent.title}</p>
            <img src={helpContent.imageSrc} alt={helpContent.imageAlt} style={{ width: '264px' }} />
            <p>{helpContent.description}</p>
        </div>
    );
};

export default UATnowAction360;